import React, { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Layout from "../../layouts";
import Breadcrumb from "../../components/Breadcrumb";

export default function Main() {
  return (
    <Layout mType="school">
      <div className="container mx-auto">
        <div className="py-5 lg:px-0 px-4">
          <Breadcrumb mType="school" currentPage="Home" />

          <div className="lg:flex lg:flex-row-reverse">
            <div className="lg:flex-1 lg:ml-10">
              <div className="mb-8">
                <h2 className="font-bold text-lg mb-4">
                  Library External Membership: School
                </h2>
                <div className="bg-orange-50 px-6 py-6">
                  <div className="mb-4">
                    <p className="font-bold">Who is eligible?</p>
                    <p>
                      <span className="bg-yellow-200">
                        -- Please provide text to replace it here --
                      </span>
                    </p>
                  </div>
                  <div className="mb-4">
                    <p className="font-bold">Fees and charges</p>
                    <div className="mb-4">
                      <p className="font-bold">Reader Card</p>
                      <p className="mb-3">
                        School Library Reader Card provides you with
                        access to both the Mong Man Wai Library and the Tseung
                        Kwan O Study Centre Library. Free remote access to
                        selected electronic databases are also provided.
                      </p>
                      <p>The annual fee is $100.</p>
                    </div>
                  </div>
                  <div className="mb-4">
                    <p className="font-bold">Enquiries</p>
                    <p>
                      Please contact our Access Services Section by phone at
                      2948-6658 or email to libcir@eduhk.hk.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:w-96 lg:mt-0 mt-5">
              <Link
                to={`/school/app/new`}
                className="border rounded flex items-center px-4 py-4 mb-4 hover:bg-gray-100 transition duration-200"
              >
                <svg
                  class="w-10 h-10 mr-2 text-orange-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  ></path>
                </svg>
                <span className="font-bold text-orange-600">
                  New Application
                </span>
              </Link>
              <Link
                to={`/school/app/renew`}
                className="border rounded flex items-center px-4 py-4 mb-4 hover:bg-gray-100 transition duration-200"
              >
                <svg
                  class="w-10 h-10 mr-2 text-orange-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                  ></path>
                </svg>
                <span className="font-bold text-orange-600">Renewal</span>
              </Link>
              <Link
                to={`/school/app/repl`}
                className="border rounded flex items-center px-4 py-4 mb-4 hover:bg-gray-100 transition duration-200"
              >
                <svg
                  class="w-10 h-10 mr-2 text-orange-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                  ></path>
                </svg>
                <span className="font-bold text-orange-600">
                  Card Replacement
                </span>
              </Link>
              <Link
                to={`/school/status`}
                className="border rounded flex items-center px-4 py-4 mb-4 hover:bg-gray-100 transition duration-200"
              >
                <svg
                  class="w-10 h-10 mr-2 text-orange-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122"
                  ></path>
                </svg>
                <span className="font-bold text-orange-600">
                  Track Your Application
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
